import '@shopify/polaris/build/esm/styles.css';
import './App.css';
import './index.css';

import translations from '@shopify/polaris/locales/es.json';
import { AppProvider } from '@shopify/polaris';
import { BrowserRouter, Route } from 'react-router-dom';
import React, { useEffect, useReducer } from 'react';
import AppFrame from './components/Layout/AppFrame';
import Login from './components/Layout/Login.js';
import UserContext, { initialState as initialStateUser } from './context/UserContext.js';
import UserReducer, { USER_LOGOUT } from './context/UserReducer.js';
import { USER_LOGGED } from './context/UserReducer';
import ToastContext, { initialState as initialStateToast } from './context/ToastContext';
import ToastReducer from './context/ToastReducer';
import { CurrencyProvider } from './providers/currency.provider';
import { TimezoneProvider } from './providers/timezone.provider';
import { SearchParamsProvider } from './providers/searchParams.provider';
import { QueryClient, QueryClientProvider } from 'react-query';
import { GlobalStatusProvider } from './context/GlobalStatusContext';

function App() {
  const theme = {
    logo: {
      width: 100,
      topBarSource: '/mirtomex_logo.png',
      accessibilityLabel: 'MIRTO',
      url: '/dashboard',
    },
    colors: {
      primary: '#53a6d8',
      secondary: '#88cdf6',
      interactive: '#53a6d8',
    },
  };
  const [state, dispatch] = useReducer(UserReducer, initialStateUser);
  const [stateToast, dispatchToast] = useReducer(ToastReducer, initialStateToast);

  useEffect(() => {
    const user = JSON.parse(window.localStorage.getItem('user'));
    if (user) {
      const expiresDate = new Date(user.expiresDate);
      dispatch(expiresDate.getTime() < Date.now() ? { type: USER_LOGOUT } : { type: USER_LOGGED, payload: user });
    }
  }, []);

  const { user } = state;

  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <UserContext.Provider value={[state, dispatch]}>
        <ToastContext.Provider value={[stateToast, dispatchToast]}>
          <SearchParamsProvider>
            <CurrencyProvider>
              <TimezoneProvider>
                <GlobalStatusProvider>
                  <BrowserRouter>
                    <AppProvider theme={theme} i18n={translations}>
                      {!user && <Route path="/" component={Login} />}
                      {user && <AppFrame />}
                    </AppProvider>
                  </BrowserRouter>
                </GlobalStatusProvider>
              </TimezoneProvider>
            </CurrencyProvider>
          </SearchParamsProvider>
        </ToastContext.Provider>
      </UserContext.Provider>
    </QueryClientProvider>
  );
}

export default App;
